import React from 'react';
import JobTracker from './components/JobTracker';
import './App.css';

function App() {
  return (
    <div className="App">
      <JobTracker />
    </div>
  );
}

export default App;